export class Warrantycondition {
Id:number;
PlantId: number=0;
TrainId:  number=0;
Stage: number=0;;
Type:  number=0;;
Name:string="";
Notes:string="";
Warrantycondition1:string="";
MaxPermTds: number=0;;
MinTemp: number=0;;
MaxTemp: number=0;;
MinFeedTds: number=0;;
MaxFeedTds: number=0;;
MinPermFlow: number=0;;
MaxPermFlow:number;
CreatedAt:string="";
UpdatedAt:string="";
}